export const USER_HAS_BEEN_ONBOARDED = "userHasBeenOnboarded";
